import { motion } from "framer-motion";

const chapters = [
  {
    no: "01",
    title: "Design with intent",
    body: "I create modern, elegant websites for small businesses — crafted to look premium and convert visitors into customers.",
  },
  {
    no: "02",
    title: "Built with AI-powered tools",
    body: "Using the latest AI-powered development tools, I deliver polished, production-ready sites faster, without compromising on craft or detail.",
  },
  {
    no: "03",
    title: "Focused on results",
    body: "Every layout, animation and word is engineered around a single goal: helping your business grow with a website that performs.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-16 lg:gap-24">
          <div className="lg:sticky lg:top-32 self-start">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="flex items-center gap-4 mb-8"
            >
              <span className="h-px w-12 bg-[#d4af37]" />
              <span className="text-xs uppercase tracking-[0.3em] gold-text">About Me</span>
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="font-serif-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              A designer obsessed with the details that
              <span className="italic gold-text"> make brands feel expensive.</span>
            </motion.h2>

            <motion.div
              initial={{ opacity: 0, scale: 1.05 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="mt-12 overflow-hidden rounded-2xl border border-white/10 hidden lg:block"
            >
              <img
                src="https://images.unsplash.com/photo-1551161440-88a5c5b09ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsJTIwYXJjaGl0ZWN0dXJlJTIwYmxhY2slMjB3aGl0ZXxlbnwwfHx8fDE3ODQ4ODg3NDl8MA&ixlib=rb-4.1.0&q=85"
                alt="Minimal architecture"
                className="w-full h-[340px] object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </motion.div>
          </div>

          <div className="flex flex-col">
            {chapters.map((c, i) => (
              <motion.div
                key={c.no}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.05 }}
                className="group py-10 border-b border-white/10 grid grid-cols-[auto_1fr] gap-6 md:gap-10"
              >
                <span className="font-serif-display text-3xl md:text-4xl text-white/20 group-hover:text-[#d4af37] transition-colors duration-500">
                  {c.no}
                </span>
                <div>
                  <h3 className="font-serif-display text-2xl md:text-3xl mb-3">{c.title}</h3>
                  <p className="text-white/55 leading-relaxed text-base md:text-lg max-w-lg">
                    {c.body}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
